import React from "react"
import Skeleton from "@material-ui/lab/Skeleton"
import styles from "./FreelancerProfileSkeleton.module.scss"

const FreelancerProfileSkeleton = () => {
  return (
    <div className={styles.skeletonContainer}>
      {/* Sidebar Skeleton */}
      <div className={styles.sidebarSkeleton}>
        {/* Profile Image */}
        <div className={styles.imageContainer}>
          <Skeleton
            variant="circle"
            width={120}
            height={120}
            className={styles.skeleton}
          />
        </div>

        {/* Name */}
        <Skeleton
          variant="text"
          width="70%"
          height={28}
          className={styles.skeleton}
          style={{ margin: "0 auto 8px" }}
        />

        {/* Title/Position */}
        <Skeleton
          variant="text"
          width="90%"
          height={24}
          className={styles.skeleton}
          style={{ margin: "0 auto 24px" }}
        />

        {/* Stats Row */}
        <div className={styles.statsRow}>
          <div className={styles.stat}>
            <Skeleton variant="text" width={50} height={24} className={styles.skeleton} />
            <Skeleton variant="text" width={70} height={16} className={styles.skeleton} />
          </div>
          <div className={styles.stat}>
            <Skeleton variant="text" width={40} height={24} className={styles.skeleton} />
            <Skeleton variant="text" width={60} height={16} className={styles.skeleton} />
          </div>
          <div className={styles.stat}>
            <Skeleton variant="text" width={45} height={24} className={styles.skeleton} />
            <Skeleton variant="text" width={65} height={16} className={styles.skeleton} />
          </div>
        </div>

        {/* Hours Per Week Section */}
        <div className={styles.section}>
          <Skeleton
            variant="text"
            width="60%"
            height={24}
            className={styles.skeleton}
            style={{ margin: "0 auto 8px" }}
          />
          <Skeleton
            variant="text"
            width="40%"
            height={18}
            className={styles.skeleton}
            style={{ margin: "0 auto" }}
          />
        </div>

        {/* Languages Section */}
        <div className={styles.section}>
          <Skeleton
            variant="text"
            width="50%"
            height={24}
            className={styles.skeleton}
            style={{ margin: "0 auto 8px" }}
          />
          <Skeleton
            variant="text"
            width="70%"
            height={18}
            className={styles.skeleton}
            style={{ margin: "0 auto" }}
          />
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className={styles.contentSkeleton}>
        {/* About Freelancer Section */}
        <div className={styles.contentSection}>
          <Skeleton
            variant="text"
            width={180}
            height={32}
            className={styles.skeleton}
            style={{ marginBottom: 16 }}
          />
          <Skeleton variant="text" width="100%" height={20} className={styles.skeleton} />
          <Skeleton variant="text" width="100%" height={20} className={styles.skeleton} />
          <Skeleton variant="text" width="95%" height={20} className={styles.skeleton} />
          <Skeleton variant="text" width="80%" height={20} className={styles.skeleton} />
          <Skeleton
            variant="text"
            width={100}
            height={20}
            className={styles.skeleton}
            style={{ marginTop: 8 }}
          />
        </div>

        {/* Skills Section */}
        <div className={styles.contentSection}>
          <Skeleton
            variant="text"
            width={80}
            height={32}
            className={styles.skeleton}
            style={{ marginBottom: 16 }}
          />
          <div className={styles.skillsRow}>
            <Skeleton variant="rect" width={100} height={32} className={styles.skillTag} />
            <Skeleton variant="rect" width={120} height={32} className={styles.skillTag} />
            <Skeleton variant="rect" width={90} height={32} className={styles.skillTag} />
            <Skeleton variant="rect" width={110} height={32} className={styles.skillTag} />
            <Skeleton variant="rect" width={80} height={32} className={styles.skillTag} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FreelancerProfileSkeleton
